import { restApi } from '../../api';
import { SatisfactionSurvey, SatisfactionSurveyResolution } from './satisfactionSurvey.types';

const path = (orderId: string) => `orders/${orderId}/satisfaction-survey`;

const ELIGIBILITY_TIMEOUT_MS = 8_000;

export const satisfactionSurveyRepository = {
  get: (orderId: string) =>
    restApi.get<SatisfactionSurvey>(path(orderId), {}, { timeout: ELIGIBILITY_TIMEOUT_MS }),
  registerView: (orderId: string) => restApi.post<void>(`${path(orderId)}/views`),
  registerResolution: (orderId: string, resolution: SatisfactionSurveyResolution) =>
    restApi.patch<void>(`${path(orderId)}/views/resolution`, { resolution }),
};
